/* tslint:disable */

export enum GuidelineElementType {
  Header = 1,
  FlowchartElement = 4,
  Widget = 5,
}
